import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { skillQueryKeys } from "./skillQueryKeys";

interface Args {
  skillId: string;
  version: number;
}

/**
 * Delete a single version of a skill.
 *
 * The backend cascades the delete into the parent skill row when this was the
 * last remaining version, so the skills-list query is invalidated alongside
 * the per-skill versions query — the skill row may have disappeared.
 */
export function useDeleteVersion(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ skillId, version }: Args) =>
      skillService.deleteVersion(skillId, version, { orgId }),
    onSuccess: (_data, { skillId }) => {
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.versions(skillId),
      });
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.org(orgId),
      });
    },
  });
}
